import {
	EditSensorDataSort,
	SensorDataPoint,
} from '@Types/editSensorData.types';
import { Formik, FormikProps } from 'formik';
import { default as React, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { ConfirmModalFooter } from './ConfirmModalFooter';
import { Container } from './EditSensorData.styles';
import { DeleteModalFooter } from './DeleteModalFooter';
import EditSensorDataChart from './EditSensorDataChart';
import EditSensorDataDialog from './EditSensorDataDialog';
import EditSensorDataTable from '@Components/EditSensorDataTable';
import { PageWrapper } from '@innovyze/stylovyze';
import { addRouteNamespace } from '@Utils/actions';
import { editSensorDataInitialState } from './utils/constants';
import useGetSensorHistory from './hooks/useGetSensorHistory';
import { useGlobalization } from '@Translations/useGlobalization';

export default function EditSensorDataContent() {
	useGetSensorHistory();
	const { t } = useGlobalization();
	const history = useHistory();
	const { sensorId } = useParams<{ sensorId: string }>();
	const [confirmModalOpen, setConfirmModalOpen] = useState(false);
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);

	const backCmd = () => {
		if (formRef.current?.values) {
			const { values } = formRef.current;
			const valuesOpen = values.points.filter(
				el => typeof el.newValue === 'number',
			);
			if (valuesOpen.length === 0) {
				goToSensorEdit();
			} else {
				setDeleteModalOpen(true);
			}
		}
	};

	const formRef =
		React.useRef<
			FormikProps<{ points: SensorDataPoint[]; sort: EditSensorDataSort }>
		>();
	const goToSensorEdit = () => {
		history.push(addRouteNamespace(`sensors/${sensorId}/edit`));
	};
	const closeDeleteModal = () => {
		setDeleteModalOpen(false);
	};
	const closeConfirmModal = () => {
		setConfirmModalOpen(false);
	};

	return (
		<PageWrapper
			title={sensorId}
			applyPadding={true}
			back={{ action: backCmd, label: t('Back to Sensors') }}>
			<Container>
				<Formik
					initialValues={editSensorDataInitialState}
					onSubmit={() => undefined}>
					{formikProps => {
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						formRef.current = formikProps as any;
						return (
							<>
								<EditSensorDataDialog
									title={t('Close without saving?')}
									modalOpen={deleteModalOpen}
									closeModal={closeDeleteModal}
									goToSensorEdit={goToSensorEdit}
									footerContent={
										<DeleteModalFooter
											formRef={formRef}
											goToSensorEdit={goToSensorEdit}
											closeDeleteModal={closeDeleteModal}
										/>
									}>
									{t('You have unsaved changes.')}
									<br /> <br />
									{t(
										'Are you sure you want to leave this page without saving?',
									)}
									<br />
									<br />
									{t(`By saving these changes, please be aware
									that data edits may take several minutes to
									be reflected system-wide.`)}
								</EditSensorDataDialog>
								<EditSensorDataDialog
									title={t('Edit Sensor Data Confirmation')}
									modalOpen={confirmModalOpen}
									closeModal={closeConfirmModal}
									footerContent={
										<ConfirmModalFooter
											closeConfirmModal={
												closeConfirmModal
											}
										/>
									}>
									{t(`Please be aware that data edits may take
									several minutes to be reflected system-wide.`)}
								</EditSensorDataDialog>
								<EditSensorDataTable
									setConfirmModalOpen={setConfirmModalOpen}
								/>
							</>
						);
					}}
				</Formik>
				<EditSensorDataChart formRef={formRef} />
			</Container>
		</PageWrapper>
	);
}
